<div class="project-settings flex-column gap-4">
  <nw-project-languages-edit></nw-project-languages-edit>
  <nw-color-palette-edit></nw-color-palette-edit>
  <nw-project-users></nw-project-users>
</div>
